export const visit = (vm, at) => {
at({ "fr": { "conversations-visitor-experience-components": { "emailCapture": { "failedToPublish": "D\xE9sol\xE9, nous n'avons pas pu v\xE9rifier votre adresse e-mail." } } } });
};